import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from '@festo-ui/react';

import App from './global/App';
import 'festo-react-ui-kit/lib/main_css.css';
import '@festo-ui/react/index.css';
import '@festo-ui/web-essentials/dist/css/festo-web-essentials.min.css';
import './index.scss';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore */}
      <SnackbarProvider>
        <App />
      </SnackbarProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
